<template>
	<div class="property-assessment-card" :class="className">
		<div class="assessment-card-info">
			<div class="assessment-card-text">{{ analysisValue }}</div>
			<div class="header6">{{ analysisLabel }}</div>
		</div>
		<div class="assessment-icon-cont" :class="iconBackgroundColor">
			<div :class="iconName"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "property-assessment-card",
	props: {
		analysisValue: String,
		analysisLabel: String,
		className: String,
		iconName:
			// eslint-disable-next-line vue/require-prop-type-constructor
			"propTownship" |
			"propClassification" |
			"assesmentPerSq" |
			"buildingSquare" |
			"exteriorConst" |
			"propAge" |
			"currentTotal" |
			"currentBuilding" |
			"currentLand",
		iconBackgroundColor: String,
	},
	data() {
		return {
			value: "",
		};
	},
	methods: {},
};
</script>

<style scoped lang="scss">
.property-assessment-card {
	height: 128px;
	background: #ffffff;
	box-shadow: 16px 16px 48px rgba(0, 0, 0, 0.0994678);
	border-radius: 3px;
	margin-bottom: 20px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding-left: 30px;
	padding-right: 30px;
	.assessment-card-text {
		font-weight: 500;
		font-size: 24px;
		line-height: 36px;
		color: var(--dark-gray);
	}
	.assessment-card-info .header6 {
		color: #a6a5a5;
	}
	.assessment-icon-cont {
		width: 48px;
		height: 48px;
		border-radius: 3px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.accent {
		background-color: var(--accent);
	}
	.soft-purple {
		background-color: var(--soft-purple);
	}
	.purple {
		background-color: var(--purple);
	}
	.primary {
		background-color: var(--primary);
	}
	.propTownship {
		content: url(/image-icons/propTownship.png);
	}
	.propClassification {
		content: url(/image-icons/propClassification.png);
	}
	.assesmentPerSq {
		content: url(/image-icons/assesmentPerSq.png);
	}
	.buildingSquare {
		content: url(/image-icons/buildingSquare.png);
	}
	.exteriorConst {
		content: url(/image-icons/exteriorConst.png);
	}
	.propAge {
		content: url(/image-icons/propAge.png);
	}
	.currentTotal {
		content: url(/image-icons/currentTotal.png);
	}
	.currentBuilding {
		content: url(/image-icons/currentBuilding.png);
	}
	.currentLand {
		content: url(/image-icons/currentLand.png);
	}
}
</style>